import React from 'react';
import _ from 'lodash';
import uuid4 from 'uuid/v4';
import ReactTooltip from 'react-tooltip';

import {ChartColumn, OverviewChartSideMenu, ChartLegend} from './components';

import {withScrollbar} from 'components/withScrollbar';
import ButtonSwitch from 'components/ButtonSwitch';

import {REPORT_SHAPE} from 'ducks/occupancy';
import Tooltip from 'components/Tooltip';

import './styles.css';

const selectReportShapeOptions = [
  {label: REPORT_SHAPE.BOOKING_TYPE.label, value: REPORT_SHAPE.BOOKING_TYPE},
  {label: REPORT_SHAPE.ROOM_STATUS.label, value: REPORT_SHAPE.ROOM_STATUS},
  {label: REPORT_SHAPE.ROOM_PURPOSE.label, value: REPORT_SHAPE.ROOM_PURPOSE}
];

const ChartSideMenuTooltip = () => (
  <Tooltip
    place="right"
    type="dark"
    effect="solid"
    id="ChartSideMenu__tooltip"
    className="ChartSideMenu__tooltip"
    getContent={stringifiedData => {
      const data = stringifiedData && JSON.parse(stringifiedData);
      const shouldRender = !_.isEmpty(data);

      return (
        shouldRender && (
          <div className="">
            <div className="">{data.label}</div>
            <div className="">
              {data.totalRooms} rooms at {data.date}
            </div>
          </div>
        )
      );
    }}
  />
);

class RoomPurposeOverviewChart extends React.Component<any> {
  chartRef: any = React.createRef();

  state = {
    isScrolling: false,
    startX: 0,
    currentScrollLeft: 0
  };

  componentDidMount() {
    // required for withScrollbar
    this.props.setScrollableContainerRef(this.chartRef.current);
  }

  onMouseLeave = () => this.setState({isScrolling: false});
  onMouseUp = () => this.setState({isScrolling: false});

  onMouseDown = event =>
    this.setState({
      isScrolling: true,
      startX: event.pageX,
      currentScrollLeft: this.chartRef.current.scrollLeft
    });

  onMouseMove = event => {
    if (this.state.isScrolling) {
      event.persist();
      event.preventDefault();

      const offset = event.pageX - this.state.startX;

      this.chartRef.current.scrollLeft = this.state.currentScrollLeft - offset;
    }
  };

  render() {
    const {
      disableShapeSwitch,
      elementsList,
      tableHeaderData,
      unitsRenderer,
      resolution,
      toggleShapeRenderer,
      HorizontalScrollbar
    } = this.props;

    ReactTooltip.rebuild();

    return (
      <div className="RoomPurposeOverviewChart">
        <OverviewChartSideMenu
          totalRooms={_.round(_.get(elementsList, `[0].totalRooms`, 1))}
          tableHeaderData={tableHeaderData}
          unitsRenderer={unitsRenderer}
        />
        <div className="RoomPurposeOverviewChart__chart">
          <div className="RoomPurposeOverviewChart__switchContainer colab-centered">
            <ButtonSwitch
              options={selectReportShapeOptions}
              initialValue={REPORT_SHAPE.ROOM_PURPOSE}
              disabled={disableShapeSwitch}
              onChange={chosenValue => toggleShapeRenderer(chosenValue.value)}
            />
          </div>
          <div className="RoomPurposeOverviewChart__chart__scala">
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
          <div className="RoomPurposeOverviewChart__chart__references colab-centered">
            {REPORT_SHAPE.ROOM_PURPOSE.segments.map(segment => (
              <ChartLegend key={segment.value} segment={segment} />
            ))}
          </div>
          <div
            className="RoomPurposeOverviewChart__chart__container"
            onMouseDown={this.onMouseDown}
            onMouseUp={this.onMouseUp}
            onMouseMove={this.onMouseMove}
            onMouseLeave={this.onMouseLeave}
            ref={this.chartRef}>
            <div className="RoomPurposeOverviewChart__chart__container__content">
              {elementsList.map(element => (
                <ChartColumn
                  key={uuid4()}
                  tableHeaders={tableHeaderData}
                  tableColumn={element}
                  resolution={resolution}
                  unitsRenderer={unitsRenderer}
                />
              ))}
            </div>
            {HorizontalScrollbar}
          </div>
          {/* <ChartBarTooltip unitsRenderer={unitsRenderer} />*/}
          <ChartSideMenuTooltip />
        </div>
      </div>
    );
  }
}

export default withScrollbar(RoomPurposeOverviewChart, {vertical: false});
